export const ACTIVITY_CATEGORY_OPTIONS = [
  { value: "Sports", labelKey: "ActivityCategory.Sports" },
  { value: "Outdoors", labelKey: "ActivityCategory.Outdoors" },
  { value: "FoodDrink", labelKey: "ActivityCategory.FoodDrink" },
  { value: "Study", labelKey: "ActivityCategory.Study" },
  { value: "Games", labelKey: "ActivityCategory.Games" },
  { value: "BoardGame", labelKey: "ActivityCategory.BoardGame" },
  { value: "Social", labelKey: "ActivityCategory.Social" },
  { value: "ArtsCulture", labelKey: "ActivityCategory.ArtsCulture" },
  { value: "Music", labelKey: "ActivityCategory.Music" },
  { value: "Wellness", labelKey: "ActivityCategory.Wellness" },
  { value: "Technology", labelKey: "ActivityCategory.Technology" },
  { value: "Volunteering", labelKey: "ActivityCategory.Volunteering" },
  { value: "Other", labelKey: "ActivityCategory.Other" },
] as const;

export type ActivityCategory = (typeof ACTIVITY_CATEGORY_OPTIONS)[number]["value"];

const CATEGORY_LABEL_KEYS = new Map<string, string>(
  ACTIVITY_CATEGORY_OPTIONS.map(({ value, labelKey }) => [value, labelKey]),
);

export const getActivityCategoryLabelKey = (category?: string | null) =>
  category ? CATEGORY_LABEL_KEYS.get(category) ?? null : null;
